/** Danh sách công ty – thêm / sửa tuỳ ý */
export const companies = [
  {
  "id": "abc",
  "name": "CÔNG TY TNHH XUẤT NHẬP ĐẦU TƯ PHAN HOÀNG",
  "taxCode": "3603880180",
  "address": "Số 285, tổ 4 , ấp 3, Xã Sông Ray, Huyện Cẩm Mỹ, Tỉnh Đồng Nai, Việt Nam",
  "phone":"0353.55.8979",
  "bankAccount":"397.936.999 - Ngân hàng Techcombank - CN Đồng Nai",
  "representative":"PHAN VĂN CẢNH",  
  "businessCode":"3603880180 do Phòng đăng ký kinh doanh - Sở Kế hoạch và Đầu tư tỉnh Đồng Nai cấp ngày 02/08/2022",
  "representativePersonalId":"075092024097 cấp ngày 16/02/2022 tại Đồng Nai",
  "placeIssue":"Cẩm Mỹ",  
  "logo": "https://firebasestorage.googleapis.com/v0/b/chemimport-database.firebasestorage.app/o/logocongty%2Fabc.png?alt=media&token=61818193-7ce5-4999-96fc-95618e811d03"
}
,
  {
  "id": "def",
  "name": "CÔNG TY TNHH HÓA CHẤT TƯỜNG VY",
  "taxCode": "3603761835",
  "address": "Số 85, Đường 36, Ấp Tân Bắc, Xã Bình, Tỉnh Đồng Nai, Việt Nam",
  "phone":"0914.867.340",
  "bankAccount":"3939.2999.9 - Ngân hàng Techcombank - CN Đồng Nai",
  "representative":"HOÀNG THẾ VINH",  
  "businessCode":"3603761835 do Phòng đăng ký kinh doanh - Sở Kế hoạch và Đầu tư tỉnh Đồng Nai cấp ngày 21/10/2020",
  "representativePersonalId":"075090025067 cấp ngày 29/09/2022 tại CTCCS QL hành chính về trật tự xã hội",
  "placeIssue":"Trảng Bom", 
  "logo": "https://firebasestorage.googleapis.com/v0/b/chemimport-database.firebasestorage.app/o/logocongty%2Fghi.png?alt=media&token=35967570-0cd8-49ee-aa72-6f9a77c76cad"
}
,
 {
  "id": "ghi",
  "name": "CÔNG TY TNHH GIẢI PHÁP CÔNG NGHỆ XỬ LÝ NƯỚC THẢI VIỆT NAM",
  "taxCode": "3603794069",
  "address": "Số A11, khu phố 1, Phường Tam Hiệp, Tỉnh Đồng Nai, Việt Nam",
  "phone":"0914.867.340",
  "bankAccount":"101.974.4810 - Ngân hàng Vietcombank - CN Đồng Nai",
  "representative":"PHẠM ĐÌNH HÙNG",  
  "businessCode":"3603794069 do Phòng đăng ký kinh doanh - Sở Kế hoạch và Đầu tư tỉnh Đồng Nai cấp ngày 09/03/2021",
  "representativePersonalId":"075075008596, cấp ngày 07/09/2022 tại CTCCS QL hành chính về trật tự xã hội",
  "placeIssue":"Biên Hòa", 
  "logo": "https://firebasestorage.googleapis.com/v0/b/chemimport-database.firebasestorage.app/o/logocongty%2Fxyz.png?alt=media&token=663d4b06-63af-44fd-aa12-2cde86378a9f"
}
,
{
  "id": "jkl",
  "name": "CÔNG TY CỔ PHẦN TÍN HOÀNG PHÚC",
  "taxCode": "3603996192",
  "address": "Số 106, Đường 30/4, tổ 5C1, Khu phố 5, Xã Trảng Bom, Tỉnh Đồng Nai, Việt Nam",
  "phone":"079.3831.552",
  "bankAccount":"1053226666 - Ngân hàng Vietcombank - CN Đồng Nai",
  "representative":"LÊ MINH HIẾU",  
  "businessCode":"3603996192 do Phòng đăng ký kinh doanh - Sở Kế hoạch và Đầu tư tỉnh Đồng Nai cấp ngày 19/12/2024",
  "representativePersonalId":"075096002611, cấp ngày 16/09/2022 tại CTCCS QL hành chính về trật tự xã hội",
  "placeIssue":"Trảng Bom", 
  "logo": "https://firebasestorage.googleapis.com/v0/b/chemimport-database.firebasestorage.app/o/logocongty%2FUntitled%20design%20(13).png?alt=media&token=de810393-33e3-4ac6-8e3b-ec1fbe14b455"
},

];




/** Hàm lấy thông tin công ty theo id (mặc định trả về phần tử 0) */
export const getCompany = id =>
  companies.find(c => c.id === id) ?? companies[0];
